import { PROVIDER_NATIVE_TOKENS } from '@context/constants';

// alternative to NATIVE_SELECTOR
export const isProvidersNativeToken = (
  token: string,
  exchangeProvider?: string,
): boolean => {
  return PROVIDER_NATIVE_TOKENS[exchangeProvider || ''] === token.toUpperCase();
};
